import React, { useState, useEffect } from "react";
import { Card, CardContent, Typography, Grid } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import { Line } from "react-chartjs-2";
import "chart.js/auto";
import axios from "axios";
import {
  useAccount,
  useContractWrite,
  usePrepareContractWrite,
  useWaitForTransaction,
  useNetwork,
  useSwitchNetwork,
} from "wagmi";
import {
  prepareWriteContract,
  writeContract,
  readContract,
  waitForTransaction,
} from "@wagmi/core";
import { CircularProgress } from "@mui/material";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";
import { Button } from "@material-ui/core";
import ApexLineChart from "./SwipeableChart";
import { Checkbox } from "@material-ui/core";
import FormGroup from "@mui/material/FormGroup";
import { Select, MenuItem } from "@material-ui/core";
import { SnackbarProvider, VariantType, useSnackbar } from "notistack";
import Web3 from "web3";
import KYCForm from "./KYCFormCard";
import { MintCardNFTs } from "../pages/components/hooks/MintCardNFTs";
import CardWidget from "../pages/components/hooks/CardWidget";
import {
  NEWCOIN_ABI,
  NEWCOIN_CONTRACT,
} from "../pages/components/NewCoinContract";
import Spinner from "react-bootstrap/Spinner";

function Cards() {
  const [user, setUser] = useState([]);
  const [card_kyc_data, setcard_kyc_data] = useState([]);
  const [userCard, setCard] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isLoading, setisLoading] = useState(true);
  const [error, setError] = useState(null);
  const { address: walletAddress, connector, isConnected } = useAccount();

  const [requirement1Fulfilled, setrequirement1Fulfilled] = useState(false);
  const [requirement2Fulfilled, setrequirement2Fulfilled] = useState(false);
  const [requirement3Fulfilled, setrequirement3Fulfilled] = useState(false);
  const [requirement4Fulfilled, setrequirement4Fulfilled] = useState(false);

  const [crgBalance, setcrgBalance] = useState(0);
  const [crgMaxSupply, setcrgMaxSupply] = useState(0);
  const [crgTotalSupply, setcrgTotalSupply] = useState(0);
  const [crgPrice, setcrgPrice] = useState(0);
  const [totalmaxsupply, settotalmaxsupply] = useState(0);

  useEffect(() => {
    if (user) {
      // console.log("set user", JSON.stringify(user));
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("userCard", JSON.stringify(userCard));
      localStorage.setItem("card_kyc_data", JSON.stringify(card_kyc_data));
    }
  }, [user, card_kyc_data, userCard]);

  //GET USER DATA
  useEffect(() => {
    if (isConnected) {
      console.log("isConnected Mint");
      console.log("address", walletAddress);
      axios
        .get(
          `https://test.croesus-asset.management/api/user-data?address=${walletAddress}`
        )
        .then((response) => {
          console.log("useEffect", response.data);
          setUser(response.data.user);
          setcard_kyc_data(response.data.card_kyc_data);
          setCard(response.data.card);

          if (response.data.nftCounts["I-Charge"].overall >= 10) {
            setrequirement2Fulfilled(true);
            setrequirement4Fulfilled(true);
          }
          if (parseInt(response.data.user.crg_balance) >= 10) {
            setrequirement1Fulfilled(true);
          }
          if (parseInt(response.data.user.matrix) >= 3) {
            setrequirement3Fulfilled(true);
          }

          setisLoading(false);
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      console.log("disconnected");
    }
  }, [isConnected, walletAddress]);

  const nftCards = [
    {
      id: 3,
      name: "VIP Metal",
      image: "image_url_3",
      price: "2000",
      quantity: 100,
      mintCondition: "Condition 3",
    },
    {
      id: 2,
      name: "Premium",
      image: "image_url_2",
      price: "400",
      quantity: 500,
      mintCondition: "Condition 2",
    },
    {
      id: 1,
      name: "Standard",
      image: "image_url_1",
      price: "100",
      quantity: "",
      mintCondition: "Condition 1",
    },
  ];

  const fetchCoinDetails = async () => {
    try {
      const CoinData = await readContract({
        address: NEWCOIN_CONTRACT,
        abi: NEWCOIN_ABI,
        functionName: "checkAirdrop",
        args: [walletAddress],
      });
      console.log("CoinData:", CoinData);

      const CRGBalance = await readContract({
        address: NEWCOIN_CONTRACT,
        abi: NEWCOIN_ABI,
        functionName: "balanceOf",
        args: [walletAddress],
      });
      console.log("CRGBalance:", CRGBalance);
      const CRGBalance_InEther = Web3.utils.fromWei(
        String(CRGBalance),
        "ether"
      );
      setcrgBalance(Number(CRGBalance_InEther));

      const CRGMaxSupply = await readContract({
        address: NEWCOIN_CONTRACT,
        abi: NEWCOIN_ABI,
        functionName: "maxSupply",
      });
      const CRGMaxSupply_InEther = Web3.utils.fromWei(
        String(CRGMaxSupply),
        "ether"
      );
      console.log("CRGMaxSupply:", CRGMaxSupply);
      setcrgMaxSupply(CRGMaxSupply);

      const CRGTotalSupply = await readContract({
        address: NEWCOIN_CONTRACT,
        abi: NEWCOIN_ABI,
        functionName: "totalSupply",
      });
      const CRGTotalSupply_InEther = Web3.utils.fromWei(
        String(CRGTotalSupply),
        "ether"
      );
      console.log("CRGTotalSupply:", CRGTotalSupply);
      setcrgTotalSupply(CRGTotalSupply);

      // Add checks for division by zero
      if (CRGMaxSupply_InEther - CRGTotalSupply_InEther !== 0) {
        const CRG_Price =
          10000000 / (CRGMaxSupply_InEther - CRGTotalSupply_InEther);
        console.log("CRG_Price:", CRG_Price);
        setcrgPrice(CRG_Price.toFixed(2));
      } else {
        console.log("Cannot divide by zero. Check your inputs.");
      }

      const totalmaxsupply = CRGMaxSupply - CRGTotalSupply;
      settotalmaxsupply(totalmaxsupply);

      console.log("totalmaxsupply ! ", totalmaxsupply);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div
      className="pt-3"
      style={{ minHeight: window.screen.height + 80, paddingTop: 0 }}
    >
      <div className="container-fluid text-center mb-2">
        <div className="row mt-2 mb-2 justify-content-md-center">
          <div className="col-12 col-xl-6 col-md-6">
            <div className="card p-3">
              <div className="card-header text-center p-0 flex-wrap">
                <h3>Cards</h3>
              </div>
              <div className="card-body">
                {/* <h5>KYC complete needed</h5> */}

                {card_kyc_data?.isKycAccepted === "true" ? (
                  user?.card?.card_type !== "0" ? (
                    <>
                      <CardWidget
                        user={user}
                        userCard={userCard}
                        card_kyc_data={card_kyc_data}
                      />
                    </>
                  ) : (
                    nftCards.map((card) => (
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        key={card.id}
                        className="mt-2"
                      >
                        <Card>
                          <CardContent>
                            <Typography variant="h5">{card.name}</Typography>
                            {/* <img
                            src={card.image}
                            alt={card.name}
                            style={{ width: "100%" }}
                          /> */}
                            <div
                              className="container mb-2"
                              style={{
                                height: "170px",
                                background: "black",
                                borderRadius: "10px",
                              }}
                            ></div>
                            <Typography variant="h6">
                              {card.price} USDT
                            </Typography>
                            <Typography variant="h6">
                              {card.quantity} / {card.quantity}
                            </Typography>
                            {/* <Typography variant="h6">
                            Minting Condition: {card.mintCondition}
                          </Typography> */}
                            {card.id === 1 ? (
                              <>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  className="mt-3"
                                >
                                  Mint
                                </Button>
                                <MintCardNFTs
                                  walletAddress={walletAddress}
                                  card={card.id}
                                  totalmaxsupply={totalmaxsupply}
                                />
                              </>
                            ) : (
                              <>
                                {card.id === 2 ? (
                                  <>
                                    <div
                                      className="d-flex "
                                      style={{
                                        flexDirection: "column",
                                        alignItems: "flex-start",
                                      }}
                                    >
                                      <h6 className="p-3 pb-0">At Least :</h6>
                                      <div>
                                        <Checkbox
                                          checked={requirement1Fulfilled}
                                          style={{
                                            color:
                                              requirement1Fulfilled == true
                                                ? "#01b35c"
                                                : "#000000",
                                          }}
                                        />
                                        <span>10x CRG</span>
                                      </div>
                                      <div>
                                        <Checkbox
                                          checked={requirement2Fulfilled}
                                          style={{
                                            color:
                                              requirement2Fulfilled == true
                                                ? "#01b35c"
                                                : "#000000",
                                          }}
                                        />
                                        <span>10x I-Charge NFT</span>
                                      </div>
                                    </div>

                                    <Button
                                      variant="contained"
                                      color="primary"
                                      className="mt-3"
                                      disabled={
                                        requirement1Fulfilled == false ||
                                        requirement2Fulfilled == false
                                      }
                                    >
                                      Mint
                                    </Button>
                                    <MintCardNFTs
                                      walletAddress={walletAddress}
                                      card={card.id}
                                      totalmaxsupply={totalmaxsupply}
                                    />
                                  </>
                                ) : (
                                  <>
                                    <div
                                      className="d-flex "
                                      style={{
                                        flexDirection: "column",
                                        alignItems: "flex-start",
                                      }}
                                    >
                                      <h6 className="p-3 pb-0">At Least :</h6>
                                      <div>
                                        <Checkbox
                                          checked={requirement3Fulfilled}
                                          style={{
                                            color:
                                              requirement3Fulfilled == true
                                                ? "#01b35c"
                                                : "#000000",
                                          }}
                                        />
                                        <span>Matrix Level 3</span>
                                      </div>
                                      <div>
                                        <Checkbox
                                          checked={requirement4Fulfilled}
                                          style={{
                                            color:
                                              requirement4Fulfilled == true
                                                ? "#01b35c"
                                                : "#000000",
                                          }}
                                        />
                                        <span>10x I-Charge NFT</span>
                                      </div>
                                    </div>

                                    <Button
                                      variant="contained"
                                      color="primary"
                                      className="mt-3"
                                      disabled={
                                        requirement3Fulfilled == false ||
                                        requirement4Fulfilled == false
                                      }
                                    >
                                      Mint
                                    </Button>
                                    <MintCardNFTs
                                      walletAddress={walletAddress}
                                      card={card.id}
                                      totalmaxsupply={totalmaxsupply}
                                    />
                                  </>
                                )}
                              </>
                            )}
                          </CardContent>
                        </Card>
                      </Grid>
                    ))
                  )
                ) : (
                  <>
                    {card_kyc_data?.kyc_step === "4" ? (
                      <>
                        {/* <Spinner /> <h4>Loading...</h4> */}
                        <h3 className="text-warning">
                          KYC data submitted. <br></br>The process may take up
                          to 72 hours.
                        </h3>
                      </>
                    ) : (
                      <>
                        {isLoading ? (
                          <>
                            <Spinner /> <h4>Loading...</h4>
                          </>
                        ) : (
                          <KYCForm />
                        )}
                      </>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Cards;
